import {targets, useReferentialContext} from "../../Context";
import React, {Dispatch, SetStateAction, useEffect, useState} from "react";
import {
    CompetitiveGames,
    CompetitiveRoundSummaries,
    CompetitiveTeamRoundSummaries,
    Maps,
    Player,
    Team
} from "../../reckon-api";
import WindowContainer from "../../components/layout/WindowContainer";
import SpecificGameSelectorDialog, {MultipleGameSelectorDialog} from "../../components/selectors/Competitive/SpecificGameSelectorDialog";
import {Grid, Stack, ToggleButton, Typography} from "@mui/material";
import PlayerSelect from "../../components/selectors/PlayerSelect";
import {SideSelect} from "../../components/selectors/YesNoSelector";
import {HeatmapKillsRender} from "../../components/Maps/HeatmapKillsRender";
import TeamIcon from "../../components/Icons/TeamIcon";
import AgentIcon from "../../components/Icons/AgentIcon";
import WeaponIcon from "../../components/Icons/WeaponIcon";
import {NeonTab, NeonTabs} from "../../NeonComponents/NeonTabs";
import {NeonToggleButton} from "../../NeonComponents/NeonToggle";
import {NeonCard, NeonCardHeader} from "../../NeonComponents/NeonCards";
import {NeonRow} from "../../NeonComponents/NeonRow";
import {scrollable} from "../../theme";
import {SmokesHeatmapRender} from "../../components/Maps/SmokesMapRender";
import AbilityIcon from "../../components/Icons/AbilityIcon";
import SpecificRoundSelector from "../../components/selectors/Competitive/SpecificRoundSelector";
import {TimestampRangeInRoundSelect} from "../../components/selectors/TimestampRangeSelect";
import {PositionMapRender} from "../../components/Maps/PositionsMapRender";
import Box from "@mui/material/Box";

export default function PositionHeatmap(props: {target: targets}){
    const context = useReferentialContext();
    const [team, setTeam] = useState(context.selectedTeam as Team|null);
    const [game, updateGame] = useState(null as CompetitiveGames|null);
    const [players, setPlayers] = useState([] as Player[]);
    const [side, setSide] = useState(null as null|string);
    const [timestampRange, setTimestampRange] = useState([1,30]);
    const [roundsSelected, setRoundsSelected] = useState([] as CompetitiveTeamRoundSummaries[]);
    const [selectedRoundSummaries, setSelectedRoundSummaries] = useState([] as CompetitiveRoundSummaries[]);
    const [map, setMap] = useState(undefined as Maps|undefined);

    useEffect(() => {
        if(game && roundsSelected.length > 0){
            setMap(context.mapsReferential.filter(m => m.id === game.map)[0])
         const request_parameters = {
            game: game.id,
            additional_filters: {
                player__in: players.map(p => p.id).toString(),
                round_index__in: roundsSelected.map(r => r.round_index).toString()
            }
        }
        context.reckonApi.competitiveRoundSummaries.list(request_parameters).then(r => setSelectedRoundSummaries(r));
        }else{
            setSelectedRoundSummaries([]);
        }
    }, [game, players, side, roundsSelected]);

    return <Grid container spacing={1} columns={12} sx={{padding:'10px', width:'100%', height:'85%'}}>
        <Grid size={12}>
        <SpecificGameSelectorDialog game={game} setGame={updateGame} target={props.target} team={team} setTeam={setTeam}/>
            </Grid>
        <Grid size={12}>
        <Stack direction={'row'} spacing={1}>
           <SideSelect value={side} onChange={setSide}/>
                {
                    context.playersReferential.filter(p => p.current_team === team?.id).map(player =>
                        <NeonToggleButton sx={{width:'100px'}} selected={players.includes(player)} value={player} onClick={() => {
                            if(players.includes(player)){
                                setPlayers(players.filter(p => p.id !== player.id));
                            }else{
                                setPlayers([...players, player])
                            }
                        }}>{player.id}</NeonToggleButton>)
                }
        </Stack>
        </Grid>
        <Grid size={3} sx={{height:'100%'}}>
            {game && team ? <SpecificRoundSelector team={team} game={game} updateSelection={setRoundsSelected}/> : undefined}
        </Grid>
        <Grid size={9}>
            {game && team && map ? <Grid container columns={12} sx={{height:'100%'}}>
                <Grid size={2}>
                    <TimestampRangeInRoundSelect value={timestampRange} onChange={setTimestampRange}
                                             roundDuration={60}/>
                </Grid>
                <Grid size={12} sx={{height:'90%'}}>
                <PositionMapRender id={game.map} round_summaries={selectedRoundSummaries}
                                   timestamp_range={timestampRange} map={map}/>
                </Grid>
            </Grid> : undefined}
        </Grid>
    </Grid>
}